import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import type { AxiosError, AxiosResponse } from "axios";
import type { CreateTmaisBannerValidationSchema } from "../schemas/create.schema";
import { toIsoFromDateTimeParts } from '@/common/utils/dateUtils';

type UseCreateTmaisBannerProps = {
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: AxiosError) => void;
};

export const useCreateTmaisBanner = ({
  onSuccess,
  onError,
}: UseCreateTmaisBannerProps = {}) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ["createTmaisBanner"],
    mutationFn: async (form: CreateTmaisBannerValidationSchema) => {
      const bannerPayload: Record<string, any> = {
        title: form.title,
        description: form.description,
        mobile_redirect_to: form.mobile_redirect_to,
        active_at: toIsoFromDateTimeParts(form.active_at_date, form.active_at_time),
        file: form.file,
      };

      if (form.add_expiration && form.expires_at_date && form.expires_at_time) {
        bannerPayload.expires_at = toIsoFromDateTimeParts(
          form.expires_at_date,
          form.expires_at_time
        );
      }

      return await privateAxios.postForm("/tmais/banners", {
        banner: bannerPayload,
      });
    },
    onSuccess: (res) => {
      onSuccess?.(res);
    },
    onError,
  });
};
